<template>
  <!-- Card stats -->
  <b-row>
    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">7501</h5>
            <div class="text-center">
              <i
                v-b-tooltip.click="{ variant: 'white' }"
                title="Warning within 6-11 days, Alert more than 11 days
               "
              >
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <b-row>
              <b-col
                cols="auto"
                @click="applyFilter(form7501Warning, '7501 > Warning')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-yellow"
                  :icon="['far', 'triangle-exclamation']"
                  size="2xl"
                />

                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{ exportStore != null ? exportStore.form7501Warning : 0 }}
                </span>
              </b-col>
              <b-col
                cols="auto"
                @click="applyFilter(form7501Alert, '7501 > Alert')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-red"
                  :icon="['far', 'octagon-exclamation']"
                  size="2xl"
                />
                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">{{
                  exportStore != null ? exportStore.form7501Alert : 0
                }}</span>
              </b-col>
            </b-row>
          </div>
        </template>
      </stats-card>
    </b-col>
    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">Title</h5>
            <div class="text-center">
              <i
                v-b-tooltip.click="{ variant: 'white' }"
                title="Warning 10-13 days after 7501 stamp, Alert 14 days or more after 7501 stamp date

               "
              >
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <b-row>
              <b-col
                cols="auto"
                @click="applyFilter(titleWarning, 'Title > Warning')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-yellow"
                  :icon="['far', 'triangle-exclamation']"
                  size="2xl"
                />

                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{ exportStore != null ? exportStore.titleWarning : 0 }}</span
                >
              </b-col>
              <b-col
                cols="auto"
                @click="applyFilter(titleAlert, 'Title > Alert')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-red"
                  :icon="['far', 'octagon-exclamation']"
                  size="2xl"
                />
                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{ exportStore != null ? exportStore.titleAlert : 0 }}</span
                >
              </b-col>
            </b-row>
          </div>
        </template>
      </stats-card>
    </b-col>

    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">
              Title after
            </h5>
            <div class="text-center">
              <i
                v-b-tooltip.click="{ variant: 'white' }"
                title="Warning 0-5 after sold, Alert 6 or more
               "
              >
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <b-row>
              <b-col
                cols="auto"
                @click="applyFilter(titleAfterWarning, 'Title after > Warning')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-yellow"
                  :icon="['far', 'triangle-exclamation']"
                  size="2xl"
                />

                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{
                    exportStore != null ? exportStore.titleAfterWarning : 0
                  }}</span
                >
              </b-col>
              <b-col
                cols="auto"
                @click="applyFilter(titleAfterAlert, 'Title after > Alert')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-red"
                  :icon="['far', 'octagon-exclamation']"
                  size="2xl"
                />
                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{
                    exportStore != null ? exportStore.titleAfterAlert : 0
                  }}</span
                >
              </b-col>
            </b-row>
          </div>
        </template>
      </stats-card>
    </b-col>
    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">
              Released vehicles
            </h5>
            <div class="text-center">
              <i
                v-b-tooltip.click="{ variant: 'white' }"
                title="Warning within 6 days (after or before today), Alert more than 6 days ago
               "
              >
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <b-row>
              <b-col
                cols="auto"
                @click="applyFilter(releasedVehiclesWarning, 'Released vehicles > Warning')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-yellow"
                  :icon="['far', 'triangle-exclamation']"
                  size="2xl"
                />

                <span class="h1 font-weight-bold mb-0 align-middle">
                  {{
                    exportStore != null
                      ? exportStore.releasedVehiclesWarning
                      : 0
                  }}</span
                >
              </b-col>

              <b-col
                cols="auto"
                @click="applyFilter(releasedVehiclesAlert, 'Released vehicles > Alert')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-red"
                  :icon="['far', 'octagon-exclamation']"
                  size="2xl"
                />
                <span class="h1 font-weight-bold mb-0 align-middle">
                  {{
                    exportStore != null ? exportStore.releasedVehiclesAlert : 0
                  }}</span
                >
              </b-col>
            </b-row>
          </div>
        </template>
        <template slot="footer">
          <span class="text-nowrap"></span>
        </template>
      </stats-card>
    </b-col>
    <!--     <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">
              On the road
            </h5>
            <div class="text-center">
              <i
                v-b-tooltip.click="{ variant: 'white' }"
                title="Vehicles with an export load active
               "
              >
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <b-row @click="applyFilter(onTheRoad)" class="cursor-pointer">
              <b-col cols="auto">
                <font-awesome-icon
                  class="cursor-pointer text-orange"
                  :icon="['far', 'truck-container']"
                  size="2xl"
                />

                <span class="h1 font-weight-bold mb-0 align-middle">
                  {{ exportStore != null ? exportStore.onTheRoad : 0 }}</span
                ></b-col
              >
            </b-row>
          </div>
        </template>
        <template slot="footer">
          <span class="text-nowrap"></span>
        </template>
      </stats-card>
    </b-col>
 -->
    <b-col xl="3" md="6">
      <stats-card class="mb-4 min-h-ready-to-sell">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">
              Ready to sell
            </h5>
            <div class="text-center">
              <i
                v-b-tooltip.click="{ variant: 'white' }"
                title="Warning within 4 before release date or 8 days after, Alert more than 8 days after release date"
              >
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3">
            <b-row>
              <b-col
                cols="auto"
                @click="applyFilter(readyToSellWarning, 'Ready to sell > Warning')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-yellow"
                  :icon="['far', 'triangle-exclamation']"
                  size="2xl"
                />

                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{
                    exportStore != null ? exportStore.readyToSellWarning : 0
                  }}</span
                >
              </b-col>
              <b-col
                cols="auto"
                @click="applyFilter(readyToSellAlert, 'Ready to sell > Alert')"
                class="cursor-pointer"
              >
                <font-awesome-icon
                  class="cursor-pointer text-red"
                  :icon="['far', 'octagon-exclamation']"
                  size="2xl"
                />
                <span class="h1 font-weight-bold mb-0 ml-1 align-middle">
                  {{
                    exportStore != null ? exportStore.readyToSellAlert : 0
                  }}</span
                >
              </b-col>
            </b-row>
          </div>
        </template>
      </stats-card>
    </b-col>

    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">Boston</h5>
            <div class="text-center">
              <i v-b-tooltip.click="{ variant: 'white' }" id="boston-tooltip"
                ><!-- todo -->
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>

              <b-tooltip target="boston-tooltip" placement="top">
                <span class="text-success">Green</span>: All conditions are
                satisfied, and the vehicle is fully ready for export. <br />
                <span class="text-yellow">Yellow</span>: Vehicle is pending
                Visual Inspection (V.I.). <br />
                <span class="text-red">Red</span>: Vehicle is missing
                registration, has a lien, or has issues with Carfax, Recall,
                Work Orders, or Cluster.
              </b-tooltip>
            </div>
          </div>
          <div class="d-flex justify-content-between text-center mt-3">
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(bostonGreen, 'Boston > Green')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'All conditions are satisfied, and the vehicle is fully ready for export',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-success"
                :icon="['far', 'circle-check']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.bostonGreen : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(bostonYellow, 'Boston > Yellow')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title: 'Vehicle is pending Visual Inspection (V.I.)',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-yellow"
                :icon="['far', 'triangle-exclamation']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.bostonYellow : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(bostonRed, 'Boston > Red')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Vehicle is missing registration, has a lien, or has issues with Carfax, Recall, Work Orders, or Cluster',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-red"
                :icon="['far', 'octagon-exclamation']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.bostonRed : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(bostonRecalls, 'Boston > Recalls')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title: 'Number of vehicles with an active recall',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-muted"
                :icon="['far', 'car-circle-bolt']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.bostonRecalls : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(bostonNotIn, 'Boston > Not In')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Number of vehicles that haven\'t arrived at this location yet',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-orange"
                :icon="['far', 'truck-container']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.bostonNotIn : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(bostonResCarHeroes, 'Boston > Res Car Hero')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Number of vehicles reserved for the &quot;RES. CARHEROES&quot; company',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-blue"
                :icon="['far', 'shield-check']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.bostonResCarHeroes : 0 }}
              </div>
            </div>
          </div>
        </template>
      </stats-card>
    </b-col>

    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">New York</h5>
            <div class="text-center">
              <i v-b-tooltip.click="{ variant: 'white' }" id="new-york-tooltip"
                ><!-- todo -->
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>
              <b-tooltip target="new-york-tooltip" placement="top">
                <span class="text-success">Green</span>: All conditions are
                satisfied, and the vehicle is fully ready for export. <br />
                <span class="text-yellow">Yellow</span>: Vehicle is pending
                Visual Inspection (V.I.).<br />
                <span class="text-red">Red</span>: Vehicle is missing
                registration, has a lien, or has issues with Carfax, Recall,
                Work Orders, or Cluster.
              </b-tooltip>
            </div>
          </div>
          <div class="d-flex justify-content-between text-center mt-3">
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(newYorkGreen, 'New York > Green')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'All conditions are satisfied, and the vehicle is fully ready for export',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-success"
                :icon="['far', 'circle-check']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.nyGreen : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(newYorkYellow, 'New York > Yellow')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title: 'Vehicle is pending Visual Inspection (V.I.)',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-yellow"
                :icon="['far', 'triangle-exclamation']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.nyYellow : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(newYorkRed, 'New York > Red')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Vehicle is missing registration, has a lien, or has issues with Carfax, Recall, Work Orders, or Cluster',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-red"
                :icon="['far', 'octagon-exclamation']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.nyRed : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(nyRecalls, 'New York > Recalls')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title: 'Number of vehicles with an active recall',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-muted"
                :icon="['far', 'car-circle-bolt']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.nyRecalls : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(nyNotIn, 'New York > Not In')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Number of vehicles that haven\'t arrived at this location yet',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-orange"
                :icon="['far', 'truck-container']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.nyNotIn : 0 }}
              </div>
            </div>
          </div>
        </template>
      </stats-card>
    </b-col>

    <b-col xl="3" md="6">
      <stats-card class="mb-4">
        <template slot>
          <div class="d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-muted mb-0">Michigan</h5>
            <div class="text-center">
              <i v-b-tooltip.click="{ variant: 'white' }" id="michigan-tooltip"
                ><!-- todo -->
                <font-awesome-icon
                  class="cursor-pointer text-blue"
                  :icon="['far', 'circle-question']"
                />
              </i>

              <b-tooltip target="michigan-tooltip" placement="top">
                <span class="text-success">Green</span>: All conditions are
                satisfied, and the vehicle is fully ready for export. <br />
                <span class="text-yellow">Yellow</span>: Vehicle is pending
                Visual Inspection (V.I.).<br />
                <span class="text-red">Red</span>: Vehicle is missing
                registration, has a lien, or has issues with Carfax, Recall,
                Work Orders, or Cluster.
              </b-tooltip>
            </div>
          </div>
          <div class="d-flex justify-content-between text-center mt-3">
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(michiganGreen, 'Michigan > Green')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'All conditions are satisfied, and the vehicle is fully ready for export',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-success"
                :icon="['far', 'circle-check']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.michiganGreen : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(michiganYellow, 'Michigan > Yellow')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title: 'Vehicle is pending Visual Inspection (V.I.)',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-yellow"
                :icon="['far', 'triangle-exclamation']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.michiganYellow : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(michiganRed, 'Michigan > Red')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Vehicle is missing registration, has a lien, or has issues with Carfax, Recall, Work Orders, or Cluster',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-red"
                :icon="['far', 'octagon-exclamation']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.michiganRed : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(michiganRecalls, 'Michigan > Recalls')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title: 'Number of vehicles with an active recall',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-muted"
                :icon="['far', 'car-circle-bolt']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.michiganRecalls : 0 }}
              </div>
            </div>
            <div class="flex-fill px-1 pt-2 cursor-pointer" @click="applyFilter(michiganNotIn, 'Michigan > Not In')">
              <font-awesome-icon
                v-b-tooltip.hover="{
                  title:
                    'Number of vehicles that haven\'t arrived at this location yet',
                  customClass: 'export-icon-tooltip',
                }"
                class="text-orange"
                :icon="['far', 'truck-container']"
                size="2xl"
              />
              <div class="h2 font-weight-bold mb-0">
                {{ exportStore != null ? exportStore.michiganNotIn : 0 }}
              </div>
            </div>
          </div>
        </template>
      </stats-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import { SET_VEHICLES_INFO_FILTERS } from "@/modules/superAdmin/actions";
import { superAdminMixin } from "../../modules/superAdmin/mixins";
import { GET_BOARD_EXPORT } from "./actions";
export default {
  name: "BoardCardsExport",
  mixins: [superAdminMixin],
  computed: {
    ...mapState({
      exportStore: (state) => state.layout.boards.export?.data,
    }),
  },
  data() {
    return {
      form7501Warning: {
        form7501: 1,
        exportLoadFrom: this.getDateXDaysAgo(10),
        exportLoadTo: this.getDateXDaysAgo(5),
      },
      form7501Alert: {
        form7501: 1,
        exportLoadTo: this.getDateXDaysAgo(10),
      },
      titleWarning: {
        title: 1,
        titleFrom: this.getDateXDaysAgo(13),
        titleTo: this.getDateXDaysAgo(10),
      },

      titleAlert: {
        title: 1,
        titleTo: this.getDateXDaysAgo(14),
      },
      releasedVehiclesWarning: {
        releasedWarning: 1,
      },
      releasedVehiclesAlert: {
        releasedAlert: 1,
      },

      onTheRoad: {
        exportOnTheWay: 1,
      },
      titleAfterWarning: {
        titleAfterWarning: 1,
        marketPlace: 1,
      },
      titleAfterAlert: {
        titleAfterAlert: 1,
        marketPlace: 1,
      },
      readyToSellWarning: {
        readyToSellWarning: 1,
        status: "InStock",
        reserve: 0,
      },
      readyToSellAlert: {
        readyToSellAlert: 1,
        status: "InStock",
        reserve: 0,
      },
      michiganRed: {
        exportLoadRed: 1,
        exportLocation: 1,
        status: "InStock",
      },
      michiganYellow: {
        exportLoadYellow: 1,
        exportLocation: 1,
        status: "InStock",
      },
      michiganGreen: {
        exportLoadGreen: 1,
        exportLocation: 1,
        status: "InStock",
      },
      michiganRecalls: {
        location: "MICHIGAN",
        status: "InStock",
        export: 7,
        recall: 4,
      },
      michiganNotIn: {
        location: "MICHIGAN",
        status: "InStock",
        lastLocation: "QAS - EMPIRE",
        notInLocation: true,
        export: 7,
      },
      newYorkRed: {
        exportLoadRed: 1,
        exportLocation: 2,
        status: "InStock",
      },
      newYorkYellow: {
        exportLoadYellow: 1,
        exportLocation: 2,
        status: "InStock",
      },
      newYorkGreen: {
        exportLoadGreen: 1,
        exportLocation: 2,
        status: "InStock",
      },
      nyRecalls: {
        location: "NEW YORK",
        status: "InStock",
        export: 7,
        recall: 4,
      },
      nyNotIn: {
        location: "NEW YORK",
        status: "InStock",
        lastLocation: "QAS - EMPIRE",
        notInLocation: true,
        export: 7,
      },
      bostonRed: {
        exportLoadRed: 1,
        exportLocation: 7,
        status: "InStock",
      },
      bostonYellow: {
        exportLoadYellow: 1,
        exportLocation: 7,
        status: "InStock",
      },
      bostonGreen: {
        exportLoadGreen: 1,
        exportLocation: 7,
        status: "InStock",
      },
      bostonRecalls: {
        location: "BOSTON",
        status: "InStock",
        export: 7,
        recall: 4,
      },
      bostonNotIn: {
        location: "BOSTON",
        status: "InStock",
        lastLocation: "QAS - EMPIRE",
        notInLocation: true,
        export: 7,
      },
      bostonResCarHeroes: {
        reserveTo: 1801,
      },
    };
  },
  mounted() {
    this.getLogisticInformation();
  },
  methods: {
    applyFilter(filters, label = null) {
      this.resetFilters(); //Method from superAdminMixin
      this.$store.commit(SET_VEHICLES_INFO_FILTERS, {
        fields: { ...filters },
        label,
      });
      this.getVehiclesInfo(); //Method from superAdminMixin
    },
    getDateXDaysAgo(numOfDays, date = new Date()) {
      const daysAgo = new Date(date);
      daysAgo.setDate(date.getDate() - numOfDays);
      return this.formatDateString(daysAgo.toString());
    },
    getDateXDaysAfter(numOfDays, date = new Date()) {
      const daysAgo = new Date(date);
      daysAgo.setDate(date.getDate() + numOfDays);
      return this.formatDateString(daysAgo.toString());
    },
    getLogisticInformation() {
      this.$store.dispatch(GET_BOARD_EXPORT).then(() => {});
    },
    formatDateString(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const shortDate = `${year}-${month}-${day}`;
      return shortDate;
    },
  },
};
</script>

<style scoped>
.min-h-ready-to-sell {
  min-height: 160px;
}
</style>

<style>
.export-icon-tooltip .tooltip-inner {
  font-size: 1rem;
  max-width: 260px;
  padding: 0.5rem 0.75rem;
}
</style>
